"use strict";
var __decorate = (this && this.__decorate) || function (decorators, target, key, desc) {
    var c = arguments.length, r = c < 3 ? target : desc === null ? desc = Object.getOwnPropertyDescriptor(target, key) : desc, d;
    if (typeof Reflect === "object" && typeof Reflect.decorate === "function") r = Reflect.decorate(decorators, target, key, desc);
    else for (var i = decorators.length - 1; i >= 0; i--) if (d = decorators[i]) r = (c < 3 ? d(r) : c > 3 ? d(target, key, r) : d(target, key)) || r;
    return c > 3 && r && Object.defineProperty(target, key, r), r;
};
Object.defineProperty(exports, "__esModule", { value: true });
var core_1 = require("@angular/core");
var common_1 = require("@angular/common");
var timepicker_1 = require("./timepicker");
var timepicker_config_1 = require("./timepicker-config");
var timepicker_2 = require("./timepicker");
exports.NgbTimepicker = timepicker_2.NgbTimepicker;
var timepicker_config_2 = require("./timepicker-config");
exports.NgbTimepickerConfig = timepicker_config_2.NgbTimepickerConfig;
var NgbTimepickerModule = /** @class */ (function () {
    function NgbTimepickerModule() {
    }
    NgbTimepickerModule_1 = NgbTimepickerModule;
    NgbTimepickerModule.forRoot = function () { return { ngModule: NgbTimepickerModule_1, providers: [timepicker_config_1.NgbTimepickerConfig] }; };
    NgbTimepickerModule = NgbTimepickerModule_1 = __decorate([
        core_1.NgModule({ declarations: [timepicker_1.NgbTimepicker], exports: [timepicker_1.NgbTimepicker], imports: [common_1.CommonModule] })
    ], NgbTimepickerModule);
    return NgbTimepickerModule;
    var NgbTimepickerModule_1;
}());
exports.NgbTimepickerModule = NgbTimepickerModule;
//# sourceMappingURL=timepicker.module.js.map


//////////////////
// WEBPACK FOOTER
// ./temp/timepicker/timepicker.module.js
// module id = 72
// module chunks = 0